export default __webpack_public_path__ + "static/media/banner_sponsor_last.86edabe1.png";